import React, { useEffect, useState, useContext } from 'react'
import ListingTableView from '@/product/components/organisms/Product/TableView'
import { Button } from '@mui/material'
import ReportContext from '@/product/context/report/reportContext'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import DynamicAuctionListing from '../AuctionLots/dynamicListing'
import { useFormik } from 'formik'
import AuctionContext from '@/product/context/auction/auctionContext'
import DynamicListing from '../Listing/dynamicListing'
import DynamicBulkListing from '@/product/components/organisms/BulkUpload/ProjectUpload'
import DynamicManifest from '@/product/components/organisms/BulkUpload/ManifestUpload'
import DynamicBulkImage from '@/product/components/organisms/BulkUpload/ProjectImage'
import CustomCommonContext from '@/custom/context/common/commonContext'
import { useHistory } from 'react-router-dom'
import { handleRedirectInternal } from '@/product/common/components'

import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'

import CatalogSearch from './CatalogSearch'
import ManifestContext from '@/product/context/manifest/manifestContext'

import FieldHeader from './FieldHeader'

const Manifest = (props) => {
    const dynamicContext = useContext(DynamicContext)
    const { getAllExportDownload } = useContext(ReportContext)
    const { getAllManifestProducts, all_manifest_products } =
        useContext(ManifestContext)

    const auctionContext = useContext(AuctionContext)

    const {
        project_tablefields,
        project_dynamicfields,
        propertyColumnReOrder,
    } = dynamicContext

    const { all_auctions, getAllAuctions, responseStatus, clearResponse } =
        auctionContext
    const { alldata_all_dropdown } = useContext(CustomCommonContext)
    const [configValues, setConfigValues] = useState({
        qty: 1,
        auction: 1,
    })

    const history = useHistory()
    const [custom, setCustom] = useState({})
    const [tableBody, setTableBody] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
    })
    const [auctionManage, setAuctionManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
    })
    const [bulkPopup, setBulkPopup] = useState(false)
    const [aucId, setAucId] = useState('')
    const [lotStatus, setLotStatus] = useState('')
    const [bulkImagePopup, setBulkImagePopup] = useState(false)
    const [catalogPopup, setCatalogPopup] = useState(false)
    const [manifestPopup, setManifestPopup] = useState(false)

    const toggleBulkImagePopup = (popup) => {
        setBulkImagePopup({ popup })
    }
    const toggleCatalogPopup = (popup) => {
        setCatalogPopup({ popup })
    }

    const toggleBulkPopup = (popup) => {
        setBulkPopup({ popup })
    }

    const toggleManifestPopup = (popup) => {
        setManifestPopup({ popup })
    }

    const onClickEdit = (id, secondaryID, type) => {
        if (type === 'manifest') {
            handleRedirectInternal(history, `listing/manifest/${id}`)
        }
    }

    const getMultipleAction = () => {
        let actionPush = []

        actionPush.push({
            field: 'action',
            type: 'button',
            clickType: 'manifest',
            onclick: onClickEdit,
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            tooltipTitle: 'Add to Inventory',
            buttonType: 'add',
        })

        return actionPush
    }

    const tableValues = [
        {
            field: 'retailer',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Retailer',
            filterable: true,
            filterField: 'm.retailer',
        },
        {
            field: 'image_1_url',
            type: 'imagewithurl',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Image',
            filterable: true,
            filterField: 'm.image_1_url',
        },

        {
            field: 'upc',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'UPC',
            filterable: true,
            filterField: 'm.upc',
        },
        {
            field: 'asin',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'ASIN',
            filterable: true,
            filterField: 'm.asin',
        },
        {
            field: 'vendor_name',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Vendor Name',
            filterable: true,
            filterField: 'm.vendor_name',
        },
        {
            field: 'po_number',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'PO Number',
            filterable: true,
            filterField: 'm.po_number',
        },
        {
            field: 'cost_per_unit',
            type: 'price',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Cost per unit',
            filterable: true,
            filterField: 'm.cost_per_unit',
        },
        {
            field: 'quantity',
            type: 'number',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Quantity',
            filterable: true,
            filterField: 'm.quantity',
        },
        {
            field: 'manufacturer_name',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Manufacturer Name',
            filterable: true,
            filterField: 'm.manufacturer_name',
        },
        {
            field: 'manufacturer_sku',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Manufacturer SKU',
            filterable: true,
            filterField: 'm.manufacturer_sku',
        },
        {
            field: 'item_title',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Item Title',
            filterable: true,
            filterField: 'm.item_title',
        },
        {
            field: 'description',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Item Description',
            filterable: true,
            filterField: 'm.description',
        },

        {
            field: 'actual_retail',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Actual Retail Price',
            filterable: true,
            filterField: 'm.actual_retail',
        },

        {
            field: 'action',
            type: 'button',
            isMultiple: true,
            clickID: 'id',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            isMultiple: getMultipleAction(),
        },
    ]

    const formik = useFormik({
        initialValues: {
            limit: 20,
            page: 1,
            orderby: '',
            order: '',
            filters: {
                action: {
                    value: '',
                    type: 'in',
                    field: 'm.market_status',
                },
                po_number: {
                    type: 'like',
                    value: '',
                    field: 'm.po_number',
                },
                truck_number: {
                    type: 'like',
                    value: '',
                    field: 'm.truck_number',
                },
                pallet_number: {
                    type: 'like',
                    value: '',
                    field: 'm.pallet_number',
                },
            },
        },
        enableReinitialize: false,
        onSubmit: (values) => {
            setIsLoading(true)
            getAllManifestProducts(values)
        },
    })

    const [value, setValue] = useState(0)

    useEffect(() => {
        setIsLoading(true)
        getAllManifestProducts(formik.values)
    }, [])

    const additionalFilterCallBack = (data) => {
        setLotStatus(data.lots)
        setAucId(data.auctions)
    }

    const resetForm = () => {
        formik.values.filters.invoice.value = ''
        formik.values.filters.auction.value = ''
        formik.values.filters.first_name.value = ''
        formik.values.filters.last_name.value = ''
        formik.values.filters.fromdate.value = ''
        formik.values.filters.todate.value = ''

        getAllAppointments(formik.values)
    }

    const searchInfo = {
        formik: formik,
        data: [
            {
                label: 'PO Number',
                placeholder: 'Enter PO number',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'po_number',
                filter: true,
            },
            {
                label: 'Truck Number',
                placeholder: 'Enter Truck number',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'truck_number',
                filter: true,
            },
            {
                label: 'Pallet Number',
                placeholder: 'Enter Pallet number',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'pallet_number',
                filter: true,
            },
            // {
            //     label: 'Invoice ID',
            //     placeholder: 'Enter Invoice ID',
            //     class: 'col-md-4 col-sm-6 col-12',
            //     type: 'text',
            //     name: 'invoice',
            //     filter: true,
            // },
            // {
            //     label: 'Auction Name',
            //     placeholder: 'Enter Auction name',
            //     class: 'col-md-4 col-sm-6 col-12',
            //     type: 'text',
            //     name: 'auction',
            //     filter: true,
            // },
            // {
            //     label: 'First Name',
            //     placeholder: 'Enter First Name',
            //     class: 'col-md-4 col-sm-6 col-12',
            //     type: 'text',
            //     name: 'first_name',
            //     filter: true,
            // },
            // {
            //     label: 'Last Name',
            //     placeholder: 'Enter Last Name',
            //     class: 'col-md-4 col-sm-6 col-12',
            //     type: 'text',
            //     name: 'last_name',
            //     filter: true,
            // },
            // {
            //     label: 'From Date',
            //     placeholder: 'Date Ending From',
            //     class: 'col-md-4 col-sm-6 col-12',
            //     type: 'date',
            //     name: 'fromdate',
            //     filter: true,
            // },
            // {
            //     label: 'To Date',
            //     placeholder: 'Date Ending To',
            //     class: 'col-md-4 col-sm-6 col-12',
            //     type: 'date',
            //     name: 'todate',
            //     filter: true,
            // },
        ],
    }

    const tableActions = []

    useEffect(() => {
        if (all_manifest_products) {
            setTableBody(
                all_manifest_products.records.length
                    ? all_manifest_products.records
                    : []
            )
        }
        setIsLoading(false)
    }, [all_manifest_products])

    console.log('all_manifest_products', all_manifest_products)
    return (
        <>
            <div className="dashboard listing maillisting erpMisc">
                <FieldHeader type="manifest" />

                <div className="erpTabs">
                    <CustomSearch
                        searchInfo={searchInfo}
                        formik={formik}
                        advFilters={true}
                        resetForm={resetForm}
                    />

                    <CustomTable
                        formik={formik.values}
                        tableBody={tableBody}
                        tableValues={tableValues}
                        tableActions={tableActions}
                        allData={all_manifest_products}
                        isLoading={isLoading}
                        loadingTemplate={'table'}
                        changeTableFunction={getAllManifestProducts}
                    />
                </div>
            </div>
        </>
    )
}

export default Manifest
